import { useContext } from 'react';
import { ConfigContext } from '../contexts';

export const useComponentSettings = () => useContext(ConfigContext);
